<template>
  <a-drawer
    :title="title"
    :visible="visible"
    :width="900"
    :maskClosable="true"
    :destroyOnClose="true"
    placement="right"
    style="overflow: auto; padding-bottom: 53px"
    @close="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="栏目名字"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入栏目名字' }] },
            ]"
            placeholder="请输入栏目名字"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="栏目代码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'code',
              { rules: [{ required: true, message: '请输入栏目代码' }] },
            ]"
            placeholder="请输入栏目代码"
          ></a-input>
        </a-form-item>
        <a-form-item label="渠道" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            v-decorator="[
              'channelCode',
              { rules: [{ required: true, message: '请选择渠道' }] },
            ]"
            placeholder="请选择渠道"
          >
            <a-select-option
              v-for="item in channelList"
              :value="item.code"
              :key="item.code"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="上级栏目"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="model.parentId != '0'"
        >
          <a-tree-select
            style="width: 100%"
            :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
            :treeData="currentDataSource"
            v-model="model.parentId"
            placeholder="请选择父级栏目"
            :disabled="disableSubmit"
          >
          </a-tree-select>
        </a-form-item>
        <a-form-item
          label="图表id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="currentLevel > 3"
        >
          <a-input v-decorator="['chartsId']" placeholder="图表id"></a-input>
        </a-form-item>
        <a-form-item
          label="跳转链接"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['url']" placeholder="请输入跳转链接"></a-input>
        </a-form-item>
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['sort', { rules: [] }]"
            placeholder="请输入排序序号"
            type="number"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="栏目地址"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'columnUrl',
              {
                rules: [
                  {
                    message: '必须以http或者https开头',
                    pattern: /http[s]{0,1}:\/\/([\w.]+\/?)\S*/,
                  },
                ],
              },
            ]"
            placeholder="请输入栏目地址"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
    <!-- </j-modal> -->
  </a-drawer>
</template>

<script>
import { getAction, httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import { postAction } from '../../../../api/manage';

export default {
  name: 'ContentColumnModal',
  components: {
    JDate,
  },
  props: {
    channelList: { type: Array, required: false },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      disableSubmit: false,
      currentDataSource: [],
      currentLevel: '',
      columnGroup: [],
      defaultValue: [],
      dataSelect: [],
      selectGroup: [],
      selectCode: '',
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_CONTENT + '/content/column/add',
        edit: process.env.VUE_APP_CMS_CONTENT + '/content/column/edit',
      },
    };
  },
  created() {},
  // watch: {
  //   model(newVal, oldVal) {
  //     this.reloadDataSource();
  //   }
  // },
  methods: {
    add() {
      this.selectGroup = [];
      this.dataSelect = [];
      this.edit({});
    },
    edit(record) {
      this.selectGroup = [];
      this.dataSelect = [];
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.reloadDataSource();
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'name',
            'code',
            'sort',
            'channelCode',
            'chartsId',
            'url'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.defaultValue = [];
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          formData.groupIds = this.selectGroup.join(',');
          console.log('表单提交数据', formData);
          httpAction(httpurl, formData, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
              if (this.dataSelect.length > 0) {
                postAction(
                  process.env.VUE_APP_CMS_WECHAT + '/wechat/groupColumn/add',
                  {
                    columnId: that.model.id,
                    groupIds: this.dataSelect,
                  }
                ).then((res) => {
                  if (res.success) {
                    that.$message.success(res.message);
                    that.close();
                  } else {
                    that.$message.error(res.message);
                  }
                  that.confirmLoading = false;
                });
              } else {
                that.confirmLoading = false;
                that.close();
              }
            } else {
              that.confirmLoading = false;
              that.$message.warning(res.message);
            }
          });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    // selectChannel(channelCode) {
    //   this.model.parentId = '';
    //   this.reloadDataSource(channelCode);
    // },
    reloadDataSource(channelCode) {
      if (!channelCode) {
        channelCode = this.model.channelCode;
      }
      this.currentDataSource = [];
      let channelCodeValue = sessionStorage.getItem('channelCodeValue');
      getAction(
        process.env.VUE_APP_CMS_CONTENT + '/content/column/queryByChannel',
        { channelCode: 'pc_service' }
      ).then((res) => {
        if (res.success) {
          this.currentDataSource = res.result;
          console.log('dataSource', this.currentDataSource);
        }
      });
    },
    handleChange(value) {
      console.log(value);
      this.selectCode = value;
    },
    changeType() {
      if (this.model.columnType == 1) {
        this.model.parentId = 0;
      } else {
        this.model.parentId = '';
      }
    },
  },
};
</script>
<style lang="less" scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
